import { render, staticRenderFns } from "./layout-category-card.vue?vue&type=template&id=4de8d766&scoped=true&"
var script = {}
import style0 from "./layout-category-card.vue?vue&type=style&index=0&id=4de8d766&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de8d766",
  null
  
)

export default component.exports